var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserAnalytics24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 17.5H2.5c-.46 0-.833-.373-.833-.833V10c0-.46.372-.833.833-.833H5c.46 0 .833.373.833.833v6.667c0 .46-.372.833-.833.833zm5.833 0h-2.5c-.46 0-.833-.373-.833-.833V2.5c0-.46.373-.833.833-.833h2.5c.461 0 .834.373.834.833v14.167c0 .46-.373.833-.834.833zm5.834 0h-2.5c-.461 0-.834-.373-.834-.833V7.5c0-.46.373-.833.834-.833h2.5c.46 0 .833.373.833.833v9.167c0 .46-.372.833-.833.833z",
    transform: "translate(-24 -208) translate(0 70) translate(24 138)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserAnalytics24);
export default __webpack_public_path__ + "static/media/ic-user-analytics-24.b5bf75a7.svg";
export { ForwardRef as ReactComponent };